import { Locale } from '@enmon/commons';
import { Select, Space, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { languageOptionMessages, messages } from './messages';

const languageOptions = [
  { message: languageOptionMessages.en, value: Locale.EN },
  { message: languageOptionMessages.cs, value: Locale.CS },
  { message: languageOptionMessages.sk, value: Locale.SK },
  { message: languageOptionMessages.pl, value: Locale.PL },
] satisfies Array<{
  message: (typeof languageOptionMessages)[keyof typeof languageOptionMessages];
  value: Locale;
}>;

export function LanguageSwitcher({
  compact = false,
  onChange,
  value,
}: {
  compact?: boolean;
  onChange: (locale: Locale) => void;
  value: Locale;
}) {
  const intl = useIntl();
  const label = intl.formatMessage(messages.languageLabel);

  return (
    <Space orientation={compact ? 'horizontal' : 'vertical'} size={compact ? 6 : 4}>
      {compact ? null : <Typography.Text type="secondary">{label}</Typography.Text>}
      <Select
        aria-label={label}
        onChange={onChange}
        options={languageOptions.map(option => ({
          label: intl.formatMessage(option.message),
          value: option.value,
        }))}
        size={compact ? 'middle' : 'large'}
        style={{ minWidth: compact ? 132 : 180 }}
        value={value}
      />
    </Space>
  );
}
